module.exports = __webpack_public_path__ + "static/media/amine1.203ad9c2.webp";